import createReadyHandler from '@/utilities/resolvers/createReadyHandler';

// This utility exports a promise that resolves when the storage is ready.
const {
  promise: storageReadyPromise,
  resolveReady: markStorageReady,
} = createReadyHandler();

export { storageReadyPromise, markStorageReady };
